import React, { useState, useEffect } from 'react';
import { remove } from 'lodash/fp';
import { routes } from 'constants/config';
import { Spinner, Icon } from 'ui';
import { useFeatureFlags } from 'components/shared/hooks';
import useFetch from 'components/shared/hooks/useFetch';
import PreviousAttempt from './PreviousAttempt';
import PreviousAttemptWithResponses from '../../shared/PreviousAttemptWithResponses';

const AllAttempts = props => {
  const { highlightFirstAttempt } = props;
  const [attempts, setAttempts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ziggeoApiKey, setZiggeoApiKey] = useState(null);
  const [hippoPreviewBase, setHippoPreviewBase] = useState(null);
  const [hippoThumbnailBase, setHippoThumbnailBase] = useState(null);
  const hasZiggeoForAllMedia = useFeatureFlags(['ziggeo_for_all_media']);
  const { data = {} } = useFetch(
    routes.ON_DEMAND_PRACTICE.LEARNING.ATTEMPTS.ALL,
  );

  useEffect(() => {
    setLoading(false);
    if (data.attempts) {
      setAttempts(data.attempts);
    }
    if (data.ziggeoApiKey) {
      setZiggeoApiKey(data.ziggeoApiKey);
    }
    if (data.hippoThumbnailBase) {
      setHippoThumbnailBase(data.hippoThumbnailBase);
    }
    if (data.hippoPreviewBase) {
      setHippoPreviewBase(data.hippoPreviewBase);
    }
  }, [data]);

  const removeAttempt = attemptId => {
    setAttempts(prevAttempts =>
      remove(attempt => attempt.id === attemptId, prevAttempts),
    );
  };

  const renderPreviousAttempt = (attempt, index) => {
    if (attempt.scenarioType === 'conversation') {
      return (
        <PreviousAttemptWithResponses key={attempt.id} attempt={attempt} />
      );
    }

    return (
      <PreviousAttempt
        highlighted={highlightFirstAttempt && index === 0}
        key={attempt.id}
        apiKey={ziggeoApiKey}
        prompt={attempt.prompt}
        attempt={attempt}
        removeAttempt={removeAttempt}
        scenarioId={attempt.scenarioId}
        hippoPreviewBase={hippoPreviewBase}
        hippoThumbnailBase={hippoThumbnailBase}
        canRequestFeedback={attempt.canRequestFeedback}
        hasZiggeoForAllMedia={hasZiggeoForAllMedia}
      />
    );
  };

  return (
    <div className="OnDemandPracticeScenario">
      <a
        className="OnDemandPracticeScenario-backLink"
        href={routes.ON_DEMAND_PRACTICE.LEARNING.INDEX(1)}
      >
        <Icon name="back" className="mr-4" />
        {t('practice.on_demand_practice.back_link')}
      </a>
      <h2 className="ff-ss fw-b ws-pr bb-gray-lighter pb-8 mb-16 mt-16">
        {t(
          'practice.on_demand_practice.overview.learner_page.all_previous_responses.title',
        )}
      </h2>
      {loading && <Spinner />}
      {!loading && attempts.map(renderPreviousAttempt)}
    </div>
  );
};

export default props => <AllAttempts {...props} />;
